import { filter, reduce } from 'lodash'
import { promoCodeReturnData } from './return'

function calcPromoCodeValue () {
  // don't put this as global to prevent not get actualized sessions values
  const state = JSON.parse(sessionStorage.getItem('semprebem:checkout'))

  switch (state.product.alias) {
    case 'residencial':
      return residentialPromoCode(state)
    default:
      return 0
  }
}

// calculations by product
// Residential
function residentialPromoCode (state) {
  const coverage = reduce(
    filter(state.plan.items, item => item.type === 'coverage'), (total, item) => total + item.price, 0
  )
  const assistance = reduce(
    filter(state.plan.items, item => item.type === 'assistance'), (total, item) => total + item.price, 0
  )
  const gross = parseFloat(coverage + (coverage * parseFloat(state.plan.iof) / 100) + assistance).toFixed(2)
  return (gross / (1 - (state.promoCode.commission / 100))).toFixed(2).toString().replace('.', ',')
}
// End Residential calculation

export { promoCodeReturnData, calcPromoCodeValue }
